import React from "react"
import classnames from "classnames"
import styles from "./GetInTouch.less"
import gtmHandler from "AtomicUtils/gtmHandler"
import urlHandler from "AtomicUtils/urlHandler"
import { InputText, Space, InputCheckBox, A, Button, InputSelect, H3, H5, Content, Section, InputRadio, FormGroup, InputEmail } from "AtomicComponents"
import { AlertList } from "AtomicContainers"
import InputSearchable from "../InputSearchable/InputSearchable"
import fetchAPI from "AtomicUtils/fetchAPI"
import { fromLinkInputs, formLinkSubmit, formSetDefaultValues, formSetValidations } from "AtomicUtils/formHandler"
import componentParser from "AtomicUtils/componentParser"
import MESSAGES from "AtomicConstants/MESSAGES"
import { WINDOW } from "constants/environment"
import TOPICS from "./TOPICS"
import TITLES from "./TITLES"

class GetInTouch extends React.Component {
  constructor(props) {
    super(props)

    // Handling hiddenCategories -> /change-of-ownership
    const { hiddenCategories } = this.props
    const filteredTopic = TOPICS.filter((item) => {
      let visible = true
      hiddenCategories.forEach((cat) => {
        if (Number(cat) === Number(item.value)) {
          visible = false
        }
      })
      return visible
    })

    this.state = {
      form: {
        topic: {
          validations: {
            required: MESSAGES.TOPIC_REQUIRED
          }
        },
        title: {
          validations: {
            required: MESSAGES.TITLE_REQUIRED
          }
        },
        firstName: {
          validations: {
            required: MESSAGES.FIRSTNAME_REQUIRED
          }
        },
        lastName: {
          validations: {
            required: MESSAGES.LASTNAME_REQUIRED
          }
        },
        phone: {
          validations: {
            required: MESSAGES.PHONE_NUMBER_REQUIRED,
            phone: MESSAGES.PHONE_NUMBER_INVALID
          }
        },
        email: {
          validations: {
            required: MESSAGES.EMAIL_REQUIRED,
            email: MESSAGES.EMAIL_INVALID
          }
        },
        address: {
          validations: {
          }
        },
        vinRego: {
          validations: {
          }
        },
        ownership: {
          validations: {
          }
        },
        enquiry: {
          validations: {
          }
        },
        privacy: {
          validations: {
            required: MESSAGES.PRIVACY_POLICY_REQUIRED
          }
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null,
      filteredTopic: filteredTopic
    }
  }

  componentDidMount() {
    const { filteredTopic } = this.state
    const currentURL = new urlHandler(WINDOW.location.href)
    // Handling pre-selecting with topic
    if (currentURL.query.topic || currentURL.query.TOPIC) {
      const topic = currentURL.query.topic || currentURL.query.TOPIC
      formSetDefaultValues(this, {
        topic: String(filteredTopic.findIndex(item => item.slug === topic) + 1)
      }, ()=> {
        this._handleTopicChange()
      })
    }

    // Handling If we only have one Topic
    if (filteredTopic.length === 1){
      formSetDefaultValues(this, {
        topic: String(filteredTopic[0].value)
      }, ()=> {
        this._handleTopicChange()
      })
    }


    // Handling pre-filling the form by customer object
    if (this.props.customer) {
      formSetDefaultValues(this, {
        firstName: this.props.customer.firstName,
        title: this.props.customer.title,
        lastName: this.props.customer.lastName,
        phone: this.props.customer.phone,
        email: this.props.customer.email
      })
    }
  }

  _handleTopicChange = () => {
    const currentURL = new urlHandler(WINDOW.location.href)
    const { form, filteredTopic } = this.state
    if (form.topic.value){
      if (form.topic.value === "1"){
        formSetValidations(this, "vinRego", { required: MESSAGES.REGO_OR_VIN_REQUIRED })
        formSetValidations(this, "address", { })
      }
      if (form.topic.value === "2"){
        formSetValidations(this, "vinRego", { required: MESSAGES.REGO_OR_VIN_REQUIRED })
        formSetValidations(this, "address", { })
      }
      if (form.topic.value === "3"){
        formSetValidations(this, "vinRego", { required: MESSAGES.REGO_OR_VIN_REQUIRED })
        formSetValidations(this, "address", { })
      }
      if (form.topic.value === "4"){
        formSetValidations(this, "vinRego", { required: MESSAGES.REGO_OR_VIN_REQUIRED })
        formSetValidations(this, "address", { })
      }
      if (form.topic.value === "5"){
        formSetValidations(this, "vinRego", { required: MESSAGES.REGO_OR_VIN_REQUIRED })
        formSetValidations(this, "address", {
          required: MESSAGES.ADDRESS_REQUIRED,
          address: MESSAGES.ADDRESS_INVALID
        })
      }
      if (form.topic.value === "6"){
        formSetValidations(this, "vinRego", { required: MESSAGES.REGO_OR_VIN_REQUIRED })
        formSetValidations(this, "address", { })
      }
      if (form.topic.value === "7"){
        formSetValidations(this, "vinRego", { })
        formSetValidations(this, "address", { })
      }
      if (form.topic.value === "8"){
        formSetValidations(this, "vinRego", { })
        formSetValidations(this, "address", { })
      }

      const newIndex = filteredTopic.findIndex(item => item.value === form.topic.value)
      if (
        filteredTopic[newIndex] &&
        filteredTopic[newIndex].slug
      ){
        currentURL.setParam("topic", filteredTopic[newIndex].slug, true)
      }
    }
  }

  _handleSubmit = async (event) => {
    const { buttonText = "Contact us" } = this.props
    if (event) event.preventDefault()
    const { loading, form } = this.state
    if (!loading && !form.submitButton.disabled) {
      await this.setState({
        loading: true
      }, async () => {
        const { submitFormEndpoint } = this.props
        const { form } = this.state
        let body = {
          categoryTypeId: form.topic.value,
          email: form.email.value,
          enquiry: form.enquiry.value,
          firstName: form.firstName.value,
          lastName: form.lastName.value,
          phone: form.phone.value,
          title: form.title.value
        }
        if (form.topic.value === "6"){
          if (form.ownership.value === 2) body.currentVinRego = form.vinRego.value
          if (form.ownership.value === 1) body.oldVinRego = form.vinRego.value
        }
        if (form.topic.value !== "6"){
          if (form.vinRego.value) body.currentVinRego = form.vinRego.value
        }
        if (form.address.value) body.address = form.address.value.description
        if (form.address.value) body.postCode = form.address.value.postcode
        if (form.address.value) body.state = form.address.value.state
        if (form.address.value) body.suburb = form.address.value.suburb


        await fetchAPI({
          method: "POST",
          url: submitFormEndpoint,
          body: body
        })
        .then(async (response) => {
          const json = await response.json()
          const { success, errorMsg } = json
          if (!success) {
            this.setState({
              errorMessage: errorMsg,
              loading: false
            })
          } else {
            // successful
            this.setState({
              loading: false,
              success: true
            }, () => {
              gtmHandler({
                pageCategory: "Get In Touch Form",
                pageAction: `Get In Touch Form - Clicked "${buttonText.toUpperCase()}"`
              })

            })
          }
        })
        .catch((response) => {
          this.setState({
            errorMessage: response.message || `Failed with status ${response.status}`,
            loading: false
          })
        })
      })
    }
  }

  render() {
    const {
      title, introText, privacyPolicy, privacyPolicyLink, buttonText = "Contact us", thankYouComponents
    } = this.props
    const { loading, form, success, filteredTopic, errorMessage } = this.state
    if (success) {
      return componentParser(thankYouComponents)
    }

    return (
      <Section padding>
        <div className={classnames({
          [styles.GetInTouch]: true
        })}>
          <H3 withDetails>{title}</H3>
          <Content xmlString={introText} />
          <div className={classnames({
            [styles.GetInTouchForm]: true
          })}>
            <form method="POST" onSubmit={this._handleSubmit} noValidate>
              <FormGroup
                hide={filteredTopic.length === 1}
                center={filteredTopic.length !== 1}
              >
                <H5>
                About Your enquiry
                </H5>
              </FormGroup>
              <FormGroup
                hide={filteredTopic.length === 1}
              >
                <InputSelect
                  name="topic"
                  label="I'd like to know more about"
                  options={filteredTopic}
                  {...fromLinkInputs(this, "topic", this._handleTopicChange)}
                  onBlur={()=>{
                    if (filteredTopic[filteredTopic.findIndex(item => item.value === form.topic.value)]) {
                      gtmHandler({
                        pageCategory: "Get In Touch Form",
                        pageAction: `Get In Touch Form - Selected "TOPIC" - "${filteredTopic[filteredTopic.findIndex(item => item.value === form.topic.value)].label.toUpperCase()}"`
                      })
                    }
                  }}
                />
              </FormGroup>
              <FormGroup center>
                { (form.topic.value === "5" ||  form.topic.value === "6") &&
                    <H5>
                    Your current details
                    </H5>
                }
                { form.topic.value !== "5" &&  form.topic.value !== "6" &&
                    <H5>
                    About You
                    </H5>
                }
              </FormGroup>
              <FormGroup>
                <InputSelect
                  name="title"
                  label="Title"
                  options={TITLES}
                  {...fromLinkInputs(this, "title")}
                  onBlur={()=>{
                    if (form.title.value) {
                      gtmHandler({
                        pageCategory: "Get In Touch Form",
                        pageAction: `Get In Touch Form - Selected "TITLE" - "${form.title.value.toUpperCase()}"`
                      })
                    }
                  }}
                />
              </FormGroup>
              <FormGroup>
                <InputText
                  name="firstName"
                  label="First Name"
                  {...fromLinkInputs(this, "firstName")}
                  onBlur={()=>{
                    gtmHandler({
                      pageCategory: "Get In Touch Form",
                      pageAction: "Get In Touch Form - Entered \"FIRSTNAME\""
                    })
                  }}
                />
              </FormGroup>
              <FormGroup>
                <InputText
                  name="lastName"
                  label="Last Name"
                  {...fromLinkInputs(this, "lastName")}
                  onBlur={()=>{
                    gtmHandler({
                      pageCategory: "Get In Touch Form",
                      pageAction: "Get In Touch Form - Entered \"LASTNAME\""
                    })
                  }}
                />
              </FormGroup>
              <FormGroup>
                <InputText
                  name="phone"
                  label="Phone"
                  {...fromLinkInputs(this, "phone")}
                  onBlur={()=>{
                    gtmHandler({
                      pageCategory: "Get In Touch Form",
                      pageAction: "Get In Touch Form - Entered \"PHONE\""
                    })
                  }}
                />
              </FormGroup>
              <FormGroup>
                <InputEmail
                  name="email"
                  label="Email"
                  {...fromLinkInputs(this, "email")}
                  onBlur={()=>{
                    gtmHandler({
                      pageCategory: "Get In Touch Form",
                      pageAction: "Get In Touch Form - Entered \"EMAIL\""
                    })
                  }}
                />
              </FormGroup>
              <FormGroup
                hide={form.topic.value === "6" }
              >
                <InputText
                  name="vinRego"
                  label="VIN/Registration"
                  {...fromLinkInputs(this, "vinRego")}
                  onBlur={()=>{
                    gtmHandler({
                      pageCategory: "Get In Touch Form",
                      pageAction: "Get In Touch Form - Entered \"REGISTRATION OR VIN\""
                    })
                  }}
                />
              </FormGroup>

              {/* TOPIC 5: 'Updating my personal details'   */}
              <FormGroup
                hide
                show={form.topic.value === "5"}
                center={form.topic.value === "5"}
              >
                <H5>
                YOUR NEW DETAILS
                </H5>
              </FormGroup>
              <FormGroup
                hide
                show={form.topic.value === "5"}
              >
                <InputSearchable
                  name="address"
                  type="address"
                  label="Address"
                  {...fromLinkInputs(this, "address")}
                  onBlur={()=>{
                    gtmHandler({
                      pageCategory: "Get In Touch Form",
                      pageAction: "Get In Touch Form - Entered \"ADDRESS\""
                    })
                  }}
                />
              </FormGroup>

              {/* TOPIC 6: 'Changing my ownership status'   */}
              <FormGroup
                hide
                show={form.topic.value === "6"}
              >
                <InputSearchable
                  name="address"
                  type="address"
                  label="Address"
                  {...fromLinkInputs(this, "address")}
                  onBlur={() => {
                    gtmHandler({
                      pageCategory: "Get In Touch Form",
                      pageAction: "Get In Touch Form - Entered \"ADDRESS\""
                    })
                  }}
                />
              </FormGroup>
              <FormGroup
                hide
                show={form.topic.value === "6"}
                center={form.topic.value === "6"}
              >
                <H5>
                UPDATE YOUR VEHICLE OWNERSHIP STATUS
                </H5>
              </FormGroup>
              <FormGroup
                hide
                show={form.topic.value === "6"}
                center
                radio
              >
                <InputRadio
                  name="ownership"
                  value={1}
                  label="I've sold my Mazda"
                  checked
                  {...fromLinkInputs(this, "ownership")}
                />
                <InputRadio
                  name="ownership"
                  value={2}
                  label="I've bought a Mazda"
                  {...fromLinkInputs(this, "ownership")}
                />
              </FormGroup>
              <FormGroup
                hide
                show={form.topic.value === "6"}
              >
                <InputText
                  name="vinRego"
                  label="VIN/Registration"
                  {...fromLinkInputs(this, "vinRego")}
                  onBlur={()=>{
                    if(form.ownership.value === 1){
                      gtmHandler({
                        pageCategory: "Get In Touch Form",
                        pageAction: "Get In Touch Form - Entered \"OLDVINREGO\""
                      })
                    }
                    if(form.ownership.value === 2){
                      gtmHandler({
                        pageCategory: "Get In Touch Form",
                        pageAction: "Get In Touch Form - Entered \"CURRENTVINREGO\""
                      })
                    }
                  }}
                />
              </FormGroup>


              <FormGroup>
                <InputText
                  name="enquiry"
                  label="Tell us your enquiry"
                  {...fromLinkInputs(this, "enquiry")}
                  onBlur={()=>{
                    gtmHandler({
                      pageCategory: "Get In Touch Form",
                      pageAction: "Get In Touch Form - Entered \"ENQUIRY\""
                    })
                  }}
                />
              </FormGroup>
              <Space />
              <FormGroup show checkbox>
                <InputCheckBox
                  name="privacy"
                  label={
                    <span>
                      {privacyPolicy}
                      <A
                        href={privacyPolicyLink}
                        onClick={()=>{
                          gtmHandler({
                            pageCategory: "Get In Touch Form",
                            pageAction: "Get In Touch Form - Clicked \"PRIVACYPOLICY\""
                          })
                        }}
                        external>
                          <nobr>Privacy Policy</nobr>
                      </A>
                    </span>
                  }
                  {...fromLinkInputs(this, "privacy", () => {
                    gtmHandler({
                      pageCategory: "Get In Touch Form",
                      pageAction: "Get In Touch Form - Checked \"PRIVACYPOLICY\""
                    })
                  })}
                />
              </FormGroup>
              <Space />
              <Space />
              <FormGroup>
                <AlertList data={errorMessage} />
                <Button
                  styleName="black"
                  loading={loading}
                  fullWidth
                  {...formLinkSubmit(this, this._handleSubmit)}
                >
                  {buttonText}
                </Button>
              </FormGroup>

            </form>
          </div>
        </div>
      </Section>
    )
  }
}


export default GetInTouch



// WEBPACK FOOTER //
// ./src/AtomicContainers/GetInTouch/GetInTouch.jsx